export default __webpack_public_path__ + "static/media/EditPen.0529d91a.svg";